/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: Home = 0, Work = 1, Other = 2
 */
export enum Routemize_Constants_AddressType {
    HOME = 'Home',
    WORK = 'Work',
    OTHER = 'Other',
}
